import React from 'react';
import PropTypes from 'prop-types';
import Cleave from 'cleave.js/react';
import Element from './Element';

class DateForm extends React.Component {
  render() {
    const { elementClass, label, unit, errorClass, ...dateProps } = this.props;
    return (
      <Element elementClass={elementClass} label={label} unit={unit}>
        <div className="Question-Container">
          <div className={`Button Button-Selector-Occupation ${errorClass !== '' ? errorClass : ''}`}>
            <Cleave
              {...dateProps}
            />
          </div>
        </div> 
      </Element>)
  }
};

DateForm.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  elementClass: PropTypes.string,
  onChange: PropTypes.func,
}

export default DateForm;

